import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h3 className="text-xs tracking-widest uppercase text-primary-500 font-medium mb-2">Featured Topics</h3>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">深度策划的影视专题内容，带你发现更多精彩</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item) => (
            <article key={item.id} className="bg-background-50 rounded-lg overflow-hidden border border-secondary-200/60 group cursor-pointer hover:border-primary-300/40 transition-colors flex flex-col">
              <div className="relative aspect-[16/9] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs bg-primary-500 text-background-50 px-2.5 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-accent-600 mb-2 font-medium">{item.subtitle}</p>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}